import QTable from 'quasar/src/components/table/QTable.js';

export const adminContentCampaignFinancialTableColumns = (): QTable['columns'] => [
  {
    name: 'price',
    field: 'price',
    label: 'قیمت کلی',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  // {
  //   name: 'sale_discount',
  //   field: 'sale_discount',
  //   label: 'تخفیف حراجی',
  //   align: 'center',
  //   format: value => value?.toLocaleString() || value
  // },
  {
    name: 'system_discount',
    field: 'system_discount',
    label: 'تخفیف سیستمی',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'manual_discount',
    field: 'manual_discount',
    label: 'تخفیف دستی',
    align: 'center'
  },
  {
    name: 'coupon',
    field: 'coupon',
    label: 'تخفیف کوپن',
    align: 'center'
  },
  {
    name: 'discount',
    field: 'discount',
    label: 'تخفیف کل',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'payable',
    field: 'payable',
    label: 'تمام شده',
    align: 'center',
    format: value => value?.toLocaleString() || value
  },
  {
    name: 'profit',
    field: 'profit',
    label: 'سود',
    align: 'center'
  }
]